




























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SuratRujukanModalInput from "@/pages/PemeriksaanIgdPage/SuratRujukanModalInput.vue";
import { storeFaskes } from "@/store/modules/faskes";
import { storeRujukan } from "@/store/modules/rujukan";
import { storeSoap } from "@/store/modules/soap";
import DataRujukan from "@/services/DataRujukan";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import http from "@/axios/http-common";
@Component({
  components: {
    CardModalTtd,
    SuratRujukanModalInput
  }
})
export default class CardSuratRujukanRalan extends Vue {
  // @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() openTtd: boolean;
  @Prop() openModalRujukan: boolean;
  sess_login = userModule.user;
  modalOpenRujukan = false;
  btnEdit = false;
  btnCetak = false;
  btnTtd = false;
  modalOpen = false;
  pageTab = "tab-soap";
  dataRujukan: object = {};
  dtRujukan: object = {};
  responRujukan: object = {};
  tujuan: object = {};
  // tujuan = "";
  unit_tujuan_text = "";
  diagnosis = "";
  alasan = "";
  kondisi = "";
  terapi_diberikan = "";
  penunjang = "";
  terapi_diharapkan = "";

  mounted() {
    if (this.openModalRujukan == true) {
      this.openModalInput();
    }

    this.getRujukan();

    this.stateRujukanByReg();
  }
  getHumanDateTime(date) {
    return date
      ? moment(date, "DD-MM-YYYY HH:mm:ss").format("DD MMMM YYYY HH:mm:ss")
      : "";
  }
  showError(value) {
    this.$emit("err", value);
  }

  closeModal() {
    console.log("close modal");
    storeRujukan.closeInput();
  }

  get stateuser() {
    return userModule.user;
  }
  get statesoapdetail() {
    return storeSoap.detailSoap;
  }
  get statefaskes() {
    return storeFaskes.faskes;
  }
  get staterujukan() {
    return storeRujukan.rujukan;
  }
  get staterujukandetail() {
    return storeRujukan.detailrujukan;
  }

  get openInputModal() {
    return storeRujukan.showInput;
  }

  @Watch("openInputModal")
  changeOpenInputModal(val) {
    console.log("changeopeninput modal");
    console.log(val);
    if (val) {
      console.log("modal open");
      this.openModalInput();
    } else {
      console.log("modal close");
      this.modalOpenRujukan = false;
    }
  }

  stateRujukanByReg() {
    storeRujukan.act_rujukan_on_reg(this.register);
  }
  stateRujukanByRegNew() {
    storeRujukan.act_rujukan_on_reg_new(this.register);
  }
  stateRujukanById() {
    storeRujukan.act_rujukan_on_id(this.staterujukandetail["id"]);
  }
  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }
  openModalInput() {
    // this.modalOpenRujukan = true;
    storeRujukan.openInput();
    this.setDataInputRujukan();
  }
  setDataInputRujukan() {
    this.dataRujukan = {
      a: this.statesoapdetail[0]["a"],
      unit_tujuan_text: "",
      alasan: "",
      kondisi: "",
      terapi_diberikan: "",
      penunjang: "",
      terapi_diharapkan: ""
    };
    this.tujuan = this.statefaskes;
  }
  editRujukan() {
    // console.log("dtruj", this.staterujukandetail);
    // this.modalOpenRujukan = true;
    storeRujukan.openInput();
    this.dataRujukan = {
      a: this.staterujukandetail["diagnosis"],
      unit_tujuan_text: this.staterujukandetail["unit_tujuan_text"],
      alasan: this.staterujukandetail["alasan"],
      kondisi: this.staterujukandetail["kondisi"],
      terapi_diberikan: this.staterujukandetail["terapi_diberikan"],
      penunjang: this.staterujukandetail["penunjang"],
      terapi_diharapkan: this.staterujukandetail["terapi_diharapkan"]
    };
    this.tujuan = {
      id: this.staterujukandetail["tujuan"].id,
      nama: this.staterujukandetail["tujuan"].nama
    };
  }
  @Watch("dtRujukan")
  cekRujukan(v) {
    this.dtRujukan = v;
  }
  respRujukan(v) {
    this.responRujukan = v;
  }
  getRujukan() {
    appModule.setLoading(true);

    const dt = DataRujukan.getDataRujukanReg(this.register);
    dt.then(dt => {
      appModule.setLoading(false);

      this.dtRujukan = dt["data"];
      const status = dt["status"];

      // if (
      //   this.stateuser.profesi == "Dokter" ||
      //   this.stateuser.profesi == "Psikolog"
      // ) {
      //   if (status == 0) {
      //     this.btnEdit = false;
      //     this.btnCetak = false;
      //     this.btnTtd = false;
      //   } else {
      //     this.btnCetak = true;
      //     if (this.dtRujukan["signed"] == 1) {
      //       this.btnEdit = false;
      //       this.btnTtd = false;
      //     } else {
      //       this.btnEdit = true;
      //       this.btnTtd = true;
      //     }
      //   }
      // } else {
      //   if (this.dtRujukan["data"].length != 0) {
      //     this.btnCetak = true;
      //   } else {
      //     this.btnCetak = false;
      //   }
      // }
    });
  }
  modalTtd() {
    this.modalOpen = true;
  }
  passTtd(value) {
    appModule.setLoading(true);

    const dt = DataRujukan.saveDataTtdRujukan(
      this.register,
      this.staterujukandetail.dokter["id"],
      value
    );
    dt.then(dt => {
      appModule.setLoading(false);

      if (dt["data"]["status"] != 1) {
        appModule.addMsgTtd(dt["data"]["message"]);
        this.modalOpen = true;
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        this.modalOpen = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan Surat Rujukan");
        // console.log("sukses ttd");
        appModule.addMsgTtd("");
        this.stateRujukanByReg();
        // this.btnEdit = false;
        // this.btnTtd = false;
        // this.btnCetak = true;
      }
    });
  }
  cetakRujukan() {
    // this.getSpri()
    // -----------------Ini yang asli jika sudah di Build--------------------
    // const idRujukan = `${this.staterujukandetail["id"]}`;
    // const routeData = this.$router.resolve({
    //   name: "cetakSuratRujukan",
    //   params: { id: idRujukan },
    // });
    // window.open(routeData.href, "_blank");
    // -----------------^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^--------------------
    const routeData =
      http.getAPI() +
      "/surat-rujukan/" +
      this.staterujukandetail["id"] +
      "/pdf";
    window.open(routeData, "_blank");
  }
  get canEdit() {
    // console.log(this.staterujukandetail);
    return (
      this.stateuser.profesi == "Dokter" &&
      this.staterujukandetail["id"] != undefined &&
      this.staterujukan.length != 0 &&
      // this.staterujukandetail.signed == 0 &&
      this.stateuser.id == this.staterujukandetail.dokter["id"]
    );
  }
}
